
export const POST_PAYBILL_QUERYCOMMUNITYCUSTLIST = '/api/payBill/queryCommunityCustList'; // 1.根据手机号查询项目客户列表

export const POST_PAYBILL_ARREARSLIST = '/api/payBill/arrearsList'; // 欠费明细列表
export const POST_PAYBILL_PAYCONFIRM = '/api/payBill/payConfirm'; // 支付确认
export const POST_PAYBILL_GETPAYPAPER = '/api/payBill/getPayPaper'; // 获取银行支付页面
export const POST_PAYBILL_QUERYPAYLOGLIST = '/api/payBill/queryPayLogList'; // 缴费列表查询
export const POST_PAYBILL_QUERYPAYLOGDETAILLIST = '/api/payBill/queryPayLogDetailList'; // 缴费列表详情查询
export const POST_PAYBILL_QUERYBILLRECORDSLIST = '/api/payBill/queryBillRecordsList'; // 支付列表
export const POST_PAYBILL_QUERYBILLRECORDSDETAIL = '/api/payBill/queryBillRecordsDetail'; // 支付列表详情
export const POST_PAYBILL_AGAINPAYORDER = '/api/payBill/againPayOrder'; // 再次缴费
export const POST_PAYBILL_QUERYPAYSTATEENUM = '/api/payBill/queryPayStateEnum'; // 初始化
export const POST_PAYBILL_QUERYPAYORDERINFO = '/api/payBill/queryPayOrderInfo'; // 查询订单状态

export const loginGetShortMessage = '/api/login/getShortMessage'; // 获取短信验证码
export const loginDoLogin = '/api/login/doLogin'; // 登录
export const loginGetUserInfo = '/api/login/getUserInfo'; // 获取用户信息
export const loginLogout = '/api/login/logout'; // 退出
export const loginSetPassword = '/api/login/setPassword'; // 修改密码

export const PRESTORE_LIST = '/api/prestore/list'; // 预存信息列表
export const PRESTORE_QUERYRESOURCE = '/api/prestore/queryResource'; // 资源查询
export const PRESTORE_QUERYPRESTORESCHEME = '/api/prestore/queryPrestoreScheme'; // 查方案
export const PRESTORE_INSERPRESTORE = '/api/prestore/inserPrestore'; // 新增预存
export const PRESTORE_POSINSERPRESTORE = '/api/prestore/posInserPrestore'; // pos新增预存
export const PRESTORE_SYSYCORDERINFO = '/api/prestore/sysYcOrderInfo'; // 同步查询

// 发票
export const INVOICE_QUERYSGINVOICE = '/api/invoice/querySgInvoice'; // 开票数据列表
export const INVOICE_QUERYCOMPANYINFO = '/api/invoice/queryCompanyInfo'; // 公司信息查询
export const INVOICE_INVOICECOMMIT = '/api/invoice/invoiceCommit'; // 提交开票信息
export const INVOICE_QUERYINVOHISLIST = '/api/invoice/queryInvoHisList'; // 开票历史
export const INVOICE_QUERYINVOICEDETAILLIST = '/api/invoice/queryInvoiceDetailList'; // 开票明细
export const INVOICE_REDAPPLY = '/api/invoice/redApply'; // 红冲申请
export const INVOICE_INVOICE = '/api/invoice/invoice'; // 手动开票
